import cService from '@API/Dropdown/cService'
import axios from '@axios'

const { ddService } = cService(axios, {})
export default ddService
